import trLocale from 'element-ui/lib/locale/lang/tr-TR'
import home from './tr/home'

const tr = {
    language: 'Русский',
    message: {
        'home': {
            ...home,
            enterEmail: 'Lütfen e-posta girin',
            save: 'Kaydet',
            saveSuccess: 'Başarıyla kaydedildi',
            pointHistory: 'Puan geçmişi',
            type: 'Tür',
            remark: 'Not',
            pendingComment: 'Değerlendirilecek',
            commented: 'Değerlendirildi',
            selectDate: 'Tarih seç',
            loginSuccess: 'Giriş başarılı',
            loginFail: 'Giriş başarısız',
            close: 'Kapat',
            required: 'Zorunlu',
            nickname: 'Takma ad',
            enterNickname: 'Lütfen takma ad girin',
            gender: 'Cinsiyet',
            male: 'Erkek',
            female: 'Kadın',
            secret: 'Gizli',
            birthday: 'Doğum günü',
            checkoutLoadFailed: 'Ödeme bilgileri yüklenemedi. Lütfen daha sonra tekrar deneyin.',
            checkoutErrorTitle: 'Bildirim',
            goAddAddress: 'Teslimat adresi ekle',
            shop_order_selectOrAddAddress: 'Lütfen ödemeden önce bir teslimat adresi ekleyip varsayılan olarak ayarlayın.',
            shop_order_cartEmpty: 'Sepet boş, ödeme yapılamıyor.',
            shop_order_cartHasNotActive: 'Yayınlanmamış veya geçersiz ürünler var, ödeme yapılamıyor.',
            shop_order_cartHasNotMarketable: 'Satıştan kaldırılmış ürünler var, ödeme yapılamıyor.',
            shop_order_cartHasLowStock: 'Yetersiz stok, ödeme yapılamıyor.',
            shop_order_cartHasExpiredGoods: 'Bazı mağaza ürünlerinin süresi dolmuş, ödeme yapılamıyor.',
            shop_order_typeIsNull: 'Sipariş türü tanınamadı, lütfen ürün türünü kontrol edin.',
            shop_order_goodsNotFound: 'Ürün bilgisi mevcut değil veya silinmiş.',
            shop_order_giftNotForSale: 'Hediye ürünler doğrudan satın alınamaz.',
            common_message_badRequest: 'Geçersiz istek, lütfen ürünü ve parametreleri kontrol edin.',
        },
    },
    '手机号码最小长度为8位': 'Cep telefonu numarasının minimum uzunluğu 8 hanedir',
    '邮箱账号名称最小长度为6位': 'E-posta hesap adının minimum uzunluğu 6 karakterdir',
    '邮箱只能包含英文，数字等字符': "Posta kutusu yalnızca İngilizce ve sayılar gibi karakterler içerebilir",
    '请选择正确的收货地址': 'Lütfen doğru gönderim adresini seçin',
    Dict_language_status_0: 'Devre dışı',
    Dict_language_status_1: 'Etkin',
    Dict_member_label_type_1: 'Koşullu etiket',
    Dict_member_label_type_2: 'Manuel etiket',
    Dict_member_level_type_0: 'Tüketim seviyesi (LV)',
    Dict_member_level_type_1: 'Ücretli üye (VIP)',
    Dict_member_growth_action_type_1: 'Sipariş ver',
    Dict_member_growth_action_type_2: 'Günlük giriş',
    Dict_member_growth_action_type_3: 'Değerlendirme yaz',
    Dict_member_growth_action_type_4: 'Profili tamamla',
    Dict_paid_member_payment_type_0: 'Bakiye ile ödeme',
    Dict_paid_member_payment_type_1: 'WeChat Pay',
    Dict_paid_member_payment_type_2: 'Alipay',
    Dict_paid_member_payment_type_3: 'PayPal',
    Dict_paid_member_record_status_0: 'Geçerli',
    Dict_paid_member_record_status_1: 'Süresi doldu',
    Dict_paid_member_record_status_2: 'İade edildi',
    Dict_point_lottery_prize_type_0: 'Puan',
    Dict_point_lottery_prize_type_1: 'Kupon',
    Dict_point_lottery_prize_type_2: 'Fiziksel ödül',
    Dict_point_lottery_prize_type_3: 'Katıldığınız için teşekkürler',
    Dict_notification_channel_type_0: 'SMS',
    Dict_notification_channel_type_1: 'E-posta',
    Dict_notification_channel_type_2: 'Site içi mesaj',
    Dict_notification_channel_type_3: 'Anlık bildirim',
    Dict_announcement_status_0: 'Taslak',
    Dict_announcement_status_1: 'Yayınlandı',
    Dict_announcement_status_2: 'Yayından kaldırıldı',
    Dict_live_permission_status_0: 'Başvurulmadı',
    Dict_live_permission_status_1: 'İnceleniyor',
    Dict_live_permission_status_2: 'Etkinleştirildi',
    Dict_live_permission_status_3: 'Reddedildi',
    Dict_live_room_status_0: 'Başlamadı',
    Dict_live_room_status_1: 'Yayında',
    Dict_live_room_status_2: 'Sona erdi',
    Dict_live_room_status_3: 'Anormal kesinti',
    Dict_live_room_type_0: 'Platform yayını',
    Dict_live_room_type_1: 'Satıcı yayını',
    Dict_store_type_0: 'Bireysel mağaza',
    Dict_store_type_1: 'Kurumsal mağaza',
    Dict_store_sign_status_0: 'İmza bekliyor',
    Dict_store_sign_status_1: 'İmzalandı',
    Dict_store_sign_status_2: 'Feshedildi',
    Dict_store_business_change_status_0: 'İnceleme bekliyor',
    Dict_store_business_change_status_1: 'Onaylandı',
    Dict_store_business_change_status_2: 'Reddedildi',
    Dict_decoration_page_type_0: 'Ana sayfa',
    Dict_decoration_page_type_1: 'Kategori sayfası',
    Dict_decoration_page_type_2: 'Kampanya sayfası',
    Dict_decoration_page_type_3: 'Özel sayfa',
    Dict_decoration_status_0: 'Taslak',
    Dict_decoration_status_1: 'Yayınlandı',
    Dict_decoration_popup_trigger_page_0: 'Platform ana sayfası',
    Dict_decoration_popup_trigger_page_1: 'Üye merkezi',
    Dict_decoration_popup_trigger_page_2: 'Ödeme başarılı',
    Dict_decoration_popup_target_user_0: 'Tüm kullanıcılar',
    Dict_decoration_popup_target_user_1: 'Ücretsiz üyeler',
    Dict_decoration_popup_target_user_2: 'Ücretli üyeler',
    Dict_decoration_popup_frequency_0: 'Kalıcı olarak bir kez',
    Dict_decoration_popup_frequency_1: 'Her ziyarette',
    Dict_decoration_popup_frequency_2: 'Özel sıklık',
    Dict_track_event_type_page_view: 'Sayfa görüntüleme',
    Dict_track_event_type_click: 'Tıklama',
    Dict_track_event_type_add_to_cart: 'Sepete ekle',
    Dict_track_event_type_search: 'Arama',
    Dict_track_event_type_purchase: 'Satın alma',
    Dict_track_event_type_live_watch: 'Canlı izle',
    Dict_reconcile_period_type_0: 'Günlük',
    Dict_reconcile_period_type_1: 'Haftalık',
    Dict_reconcile_period_type_2: 'Aylık',
    Dict_store_settlement_status_0: 'Mutabakat bekliyor',
    Dict_store_settlement_status_1: 'Mutabık',
    Dict_distributor_status_0: 'İnceleme bekliyor',
    Dict_distributor_status_1: 'İncelendi',
    Dict_distributor_status_2: 'Reddedildi',
    Dict_distribution_commission_type_0: 'Doğrudan komisyon',
    Dict_distribution_commission_type_1: 'Dolaylı komisyon',
    Dict_configuration_status_0: 'Devre dışı',
    Dict_configuration_status_1: 'Etkin',
    ...trLocale
}
export default tr
